import { render } from "./OfferingVa.vue?vue&type=template&id=27b66d5e&scoped=true"
import script from "./OfferingVa.vue?vue&type=script&lang=js"
export * from "./OfferingVa.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hanssagita/Documents/freelance/gunsa2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b66d5e"]])

export default __exports__